import { Resources } from "../Resources";
import colinPortrait from "./../../res/colinPortrait.png";
import charPortrait from "./../../res/charPortrait.png";
import aliviaPortrait from "./../../res/AliviaPortrait.png";
import cowboyPortrait from "./../../res/cowboyPortrait.png";
import grandpaPortrait from "./../../res/grandpaPortrait.png";
import hippyChickPortrait from "./../../res/hippyChickPortrait.png";
import kaisonPortrait from "./../../res/kaisonPortrait.png";
import katiePortrait from "./../../res/katiePortrait.png";
import kennedyPortrait from "./../../res/kennedyPortrait.png";
import margiePortrait from "./../../res/margiePortrait.png";
import professorPortrait from "./../../res/professorPortrait.png";
import sparkyPortrait from "./../../res/sparkyPortrait.png";
export default class Dialog {
  constructor(content, endCallback, user, yOffset) {
    console.log("inside dialog: user is: ", user);
    this.content = content;
    this.dialogContainer = document.getElementById("dialog");
    this.dialogContainer.style.display = "flex";
    // if (yOffset == undefined || yOffset !== "top") {
    //   this.dialogContainer.style.bottom = 0;
    //   this.dialogContainer.style.top = "unset";
    // } else {
    //   this.dialogContainer.style.top = 0;
    //   this.dialogContainer.style.bottom = "unset";
    // }
    this.finished = false;
    this.index = 0;
    this.lines = 0;
    this.pauseCount = 15;
    this.chars = this.content[0].length;
    this.text = ["", "", "", ""];
    this.portrait = document.getElementById("portrait");

    this.textBox0 = document.getElementById("textBox0");
    this.textBox0.innerHTML = ``;
    this.textBox1 = document.getElementById("textBox1");
    this.textBox2 = document.getElementById("textBox2");
    this.textBox3 = document.getElementById("textBox3");
    if (user == "player") {
      this.portrait.innerHTML = `<img src="${charPortrait}"/>`;
    } else if (user == "grandpa") {
      this.portrait.innerHTML = `<img src="${grandpaPortrait}"/><h1>Grandpa</h1>`;
    } else if (user == "margie") {
      this.portrait.innerHTML = `<img src="${margiePortrait}"/>`;
    } else if (user == "roger") {
      this.portrait.innerHTML = `<img src="${cowboyPortrait}"/>`;
    } else if (user == "katie") {
      this.portrait.innerHTML = `<img src="${katiePortrait}"/>`;
    } else if (user == "colin") {
      this.portrait.innerHTML = `<img src="${colinPortrait}"/>`;
    } else if (user == "kennedy") {
      this.portrait.innerHTML = `<img src="${kennedyPortrait}"/>`;
    } else if (user == "hippyChick") {
      this.portrait.innerHTML = `<img src="${hippyChickPortrait}"/>`;
    } else if (user == "alivia") {
      this.portrait.innerHTML = `<img src="${aliviaPortrait}"/>`;
    } else if (user == "sparky") {
      this.portrait.innerHTML = `<img src="${sparkyPortrait}"/>`;
    } else if (user == "professor") {
      this.portrait.innerHTML = `<img src="${professorPortrait}"/>`;
    } else if (user == "kaison") {
      this.portrait.innerHTML = `<img src="${kaisonPortrait}"/>`;
    }
    this.finish = () => {
      endCallback();
    };
    this.startTyping();
  }
  startTyping() {
    console.log("dialog: ", this.content[0]);

    this.typing = setInterval(() => {
      if (!this.finished) {
        if (this.pauseCount < 20) {
          this.pauseCount++;
        } else if (this.pauseCount == 20) {
          this.pauseCount++;
        } else if (this.pauseCount > 20) {
          if (this.index !== this.content[this.lines].length) {
            this.text[this.lines] =
              this.text[this.lines] +
              this.content[this.lines].charAt(this.index);
            Resources.Keypress.play(0.1);
            this.index++;
          } else {
            this.lines++;
            this.index = 0;
            this.pauseCount = 0;
            if (this.lines == this.content.length) {
              console.log("dialog setting this.finished");
              this.finished = true;
            }
          }
          switch (this.lines) {
            case 0:
              this.textBox0.innerHTML = `${this.text[0]}`;
              break;
            case 1:
              this.textBox1.innerHTML = `${this.text[1]}`;
              break;
            case 2:
              this.textBox2.innerHTML = `${this.text[2]}`;
              break;
            case 3:
              this.textBox3.innerHTML = `${this.text[3]}`;
              break;
            default:
              break;
          }
        }
      }
    }, 70);
  }
  enterPress() {
    console.log("inside enterpress dialog");
    if (this.finished) {
      this.destroy();
      this.finish();
    } else {
      this.finished = true;
      this.textBox0.innerHTML = `${this.content[0]}`;
      if (this.content[1] !== undefined) {
        this.textBox1.innerHTML = `${this.content[1]}`;
      }
      if (this.content[2] !== undefined) {
        this.textBox2.innerHTML = `${this.content[2]}`;
      }
      if (this.content[3] !== undefined) {
        this.textBox3.innerHTML = `${this.content[3]}`;
      }
      clearInterval(this.typing);
    }
  }
  destroy() {
    clearInterval(this.typing);
    this.dialogContainer.style.display = "none";
    this.textBox0.innerHTML = ``;
    this.textBox1.innerHTML = ``;
    this.textBox2.innerHTML = ``;
    this.textBox3.innerHTML = ``;
  }
}
